import { CanDeactivateFn } from '@angular/router';
import CenterRolePage from './center-role.page';
import { inject } from '@angular/core';
import { AlertService } from '@malirang/front-share';

const handleAlert = (): Promise<Boolean> => {
  return new Promise((resolve, reject) => {
    const alertService = inject(AlertService);

    alertService
      .open({
        title: '저장되지 않은 변경사항',
        content: `저장하지 않은 변경사항이 있습니다.
        저장하시겠습니까?`,
        type: 'info',
        buttons: {
          confirm: {
            text: '저장',
          },
        },
      })
      .closed.subscribe({
        next: (res) => {
          resolve(res?.action === 'confirm');
        },
      });
  });
};

/**
 * 변경사항을 저장하지 않았을 경우 저장 여부를 묻는 가드
 * @param component
 * @returns
 */
export const centerRoleFormGuard: CanDeactivateFn<CenterRolePage> = async (
  component: CenterRolePage,
) => {
  // if (component.selectedRole() && !component.invalid()) {
  //   const res = await handleAlert();

  //   if (res) {
  //     component.submit();
  //   }
  // }

  return true;
};
